(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9948,1620],{

/***/ 93228:
/***/ (function(module) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),

/***/ 51704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(52153);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 82941:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRange = __webpack_require__(93228),
    isIterateeCall = __webpack_require__(82406),
    toFinite = __webpack_require__(5707);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),

/***/ 52153:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 2689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createRange = __webpack_require__(82941);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),

/***/ 5707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(7642);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 7642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(51704),
    isObject = __webpack_require__(29259),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 27456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ academy; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation2/index.ts + 91 modules
var Navigation2 = __webpack_require__(92609);
// EXTERNAL MODULE: ../../libs/api/routes/academy/queries/index.ts + 3 modules
var queries = __webpack_require__(79308);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ./src/views/Academy/components/Subnav/Subnav.tsx
var Subnav = __webpack_require__(58483);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ./src/views/Academy/components/EmailForm/EmailForm.tsx
var EmailForm = __webpack_require__(21130);
// EXTERNAL MODULE: ./src/views/Academy/components/EmailForm/SuccessMessage.tsx
var SuccessMessage = __webpack_require__(91785);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/Academy/LandingPage/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(82967);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/Academy/LandingPage/components/Hero/assets/Hero.webp
var Hero = __webpack_require__(35784);
var Hero_default = /*#__PURE__*/__webpack_require__.n(Hero);
// EXTERNAL MODULE: ./src/views/Academy/LandingPage/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(3289);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Academy/LandingPage/components/Hero/HeroImage.tsx







var HeroImage = function HeroImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((Hero_default()), ", ").concat((assets_Hero_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (Hero_2x_default()),
      alt: "Illustration: Analytics Academy",
      width: "640",
      height: "540"
    })]
  });
};

/* harmony default export */ var Hero_HeroImage = (HeroImage);
;// CONCATENATED MODULE: ./src/views/Academy/LandingPage/components/Hero/Hero.tsx







var copy = {
  overline: "Analytics Academy ",
  heading: "The right place to learn analytics",
  description: "Learn from top industry experts and level-up your analytics knowledge through these six free courses, with 38 lessons that include real-life examples and data."
};

var Hero_Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* default */.ZP, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h1",
            variant: "h1",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            children: copy.description
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Form */.l0, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailForm/* default */.Z, {
            id: "hero-email-capture-form",
            compact: true,
            success: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuccessMessage/* default */.Z, {
              align: "left"
            })
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_HeroImage, {})
      })]
    })
  });
};

/* harmony default export */ var components_Hero_Hero = (Hero_Hero);

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e12trtqp0"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var Card = __webpack_require__(74881);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ./src/views/Academy/components/LessonCard/LessonLabel.tsx
var LessonLabel = __webpack_require__(95985);
;// CONCATENATED MODULE: ./src/views/Academy/LandingPage/components/FeaturedLessons/LessonCard.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var LessonCard = function LessonCard(_ref) {
  var lesson = _ref.lesson;
  var courseIcon = lesson.courseIcon,
      courseTitle = lesson.courseTitle,
      courseNumber = lesson.courseNumber,
      lessonNumber = lesson.lessonNumber,
      numberOfLessons = lesson.numberOfLessons,
      title = lesson.title,
      description = lesson.description,
      url = lesson.url;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.ZP, {
    "data-testid": "featured-lesson",
    href: (0,getAbsoluteUrl/* default */.Z)("/academy/".concat(url), pageConfig),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Accessories */.v8, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* AccessoriesRow */.OW, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCardAuthor, {
              alt: courseIcon.title,
              src: courseIcon.src
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Label */.__, {
              variant: "textBoldSmall",
              children: courseTitle
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LessonLabel/* default */.Z, {
            courseNumber: courseNumber,
            lessonNumber: lessonNumber,
            numberOfLessons: numberOfLessons
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
          tag: "h3",
          children: title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
        alignment: "right",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronRightIcon */.XC, {})
      })]
    })
  });
};

var StyledCardAuthor = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card/* Author */.S3,  true ? {
  target: "e1nfnqhy0"
} : 0)( true ? {
  name: "1q2no33",
  styles: "border-radius:0;width:22px;height:22px;margin:0"
} : 0);

/* harmony default export */ var FeaturedLessons_LessonCard = (LessonCard);
;// CONCATENATED MODULE: ./src/views/Academy/LandingPage/components/FeaturedLessons/data.tsx
var data = [{
  url: "intro/how-to-think-about-analytics/",
  title: "How to think about analytics",
  description: "You need to think about analytics differently. In this lesson, you'll learn what a successful analytics process looks like and how to do it yourself.",
  lessonNumber: 2,
  numberOfLessons: 7,
  courseTitle: "Intro to analytics",
  courseNumber: 1,
  courseIcon: {
    src: "//images.ctfassets.net/h6ufgtwb6nv1/6Fx3NojxJI1VEIthRGnBrt/025dca566ed2f46b292203bd800e6034/icon-intro-to-analytics.svg",
    title: "icon-intro-to-analytics",
    width: 36,
    height: 36
  }
}, {
  url: "collecting-data/naming-conventions-for-clean-data/",
  title: "Naming Conventions: Why You Need Them for Clean Data",
  description: "To speed up your time to insight, you should enforce a naming convention when instrumenting analytics. In this lesson, we\u2019ll go over why you need a naming standard and our preferred approach, the object-action framework.",
  lessonNumber: 4,
  numberOfLessons: 8,
  courseTitle: "Collecting the right data",
  courseNumber: 2,
  courseIcon: {
    src: "//images.ctfassets.net/h6ufgtwb6nv1/1Mr3RAmaaIWeqJRXuK5wba/8fe2402752c0f9989fe00a6c651babb3/icon-collecting-the-right-data.svg",
    title: "icon-collecting-the-right-data",
    width: 36,
    height: 36
  }
}, {
  url: "choosing-stack/how-to-choose-the-best-performance-monitoring-tool/",
  title: "9 Best Application Performance Monitoring Tools Compared",
  description: "Performance issues destroy your customer experience. So stop them in their tracks! This lesson will give you insight into the performance monitoring vendor landscape and walk through some key considerations when it comes to selecting the right tool for your business.",
  lessonNumber: 3,
  numberOfLessons: 7,
  courseTitle: "Choosing the right stack",
  courseNumber: 3,
  courseIcon: {
    src: "//images.ctfassets.net/h6ufgtwb6nv1/5v3NWA2GrFvgHBVbfTNlFV/636280452d1140c53f9f88c79141253e/icon-choosing-the-right-stack.svg",
    title: "icon-choosing-the-right-stack",
    width: 36,
    height: 36
  }
}, {
  url: "building-data-driven-company/7-launch-day-data-mistakes-to-avoid/",
  title: "7 launch day data mistakes to avoid",
  description: "Launch day only comes around so often. So when it does, you want to make sure your using data to get the most out of this opportunity. Over the years, we've launched countless products and features, and have worked with some of the biggest companies advising them on data strategies for new launches. This chapter outlines some of the most common data pitfalls we've seen heading into launch day, and some easy strategies to avoid them.",
  lessonNumber: 1,
  numberOfLessons: 5,
  courseTitle: "Building a data driven company",
  courseNumber: 4,
  courseIcon: {
    src: "//images.ctfassets.net/h6ufgtwb6nv1/2wGkv2gxl5lO64bgXXrUjE/095a5b1b43d3530393e38f66a00b6017/icon-bulding-a-data-driven-company.svg",
    title: "icon-bulding-a-data-driven-company",
    width: 36,
    height: 36
  }
}, {
  url: "grow-using-data/how-to-create-the-best-audiences-for-your-campaigns/",
  title: "How to create the best audiences for your campaigns",
  description: "Getting the right message to the right person at the right time requires that your tools are working off the right audiences. While 1:1 communication may be out of the question as you scale, it doesn\u2019t mean you can\u2019t engage users and personal and relevant ways. Check out this lesson to learn more about the audiences every B2C and B2B company can use to guarantee high engagement.",
  lessonNumber: 3,
  numberOfLessons: 7,
  courseTitle: "Grow using data",
  courseNumber: 5,
  courseIcon: {
    src: "//images.ctfassets.net/h6ufgtwb6nv1/5Z2jI1UWnReSDpfkXH8qib/bc7129766fc9ce50a8d9ffdcd2291c8c/icon-grow-using-data.svg",
    title: "icon-grow-using-data",
    width: 36,
    height: 36
  }
}, {
  url: "advanced-analytics/take-your-product-usability-to-the-next-level/",
  title: "Product Usability: How to Measure and Improve it",
  description: "In this lesson, you'll learn how to understand your product usability metrics to better enhance adoption and engagement in your product.",
  lessonNumber: 2,
  numberOfLessons: 2,
  courseTitle: "Advanced analytics",
  courseNumber: 6,
  courseIcon: {
    src: "//images.ctfassets.net/h6ufgtwb6nv1/1BUgGyYXMEMYlKk3dqBch0/e342a73afe75acd4fc6aaa5f80457432/icon-advance-analytics.svg",
    title: "icon-advance-analytics",
    width: 36,
    height: 36
  }
}];
/* harmony default export */ var FeaturedLessons_data = (data);
;// CONCATENATED MODULE: ./src/views/Academy/LandingPage/components/FeaturedLessons/FeaturedLessons.tsx








var FeaturedLessons_copy = {
  heading: "A preview of what you\u2019ll learn from our courses",
  description: "Our handcrafted courses include basics of analytics as well as more advanced processes and strategies, to help your business grow faster."
};

var FeaturedLessons = function FeaturedLessons() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCopyTextBase, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: FeaturedLessons_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: FeaturedLessons_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
        overrides: {
          lg: 3
        },
        children: FeaturedLessons_data.map(function (lesson, key) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeaturedLessons_LessonCard, {
            lesson: lesson
          }, key);
        })
      })
    })]
  });
};

var StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "e1b0t81c0"
} : 0)("max-width:684px;margin:0 auto;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{text-align:center;}" + ( true ? "" : 0));

/* harmony default export */ var FeaturedLessons_FeaturedLessons = (FeaturedLessons);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Accordion/index.ts + 26 modules
var Accordion = __webpack_require__(83914);
// EXTERNAL MODULE: ./src/views/Academy/components/LessonCard/LessonCard.tsx
var LessonCard_LessonCard = __webpack_require__(27667);
// EXTERNAL MODULE: ./src/views/Academy/components/LabelText/LabelText.tsx
var LabelText = __webpack_require__(71336);
;// CONCATENATED MODULE: ./src/views/Academy/LandingPage/components/AvailableCourses/CourseSection.tsx


function CourseSection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var CourseSection_copy = {
  listHeading: "In this course you\u2019ll learn:",
  accordionTitle: "All lessons in this course"
};

var CourseSection = function CourseSection(_ref) {
  var course = _ref.course;
  var title = course.title,
      courseNumber = course.courseNumber,
      lessons = course.lessons,
      courseIcon = course.courseIcon;

  var _useState = (0,react.useState)(false),
      accordionOpen = _useState[0],
      setAccordionOpen = _useState[1];

  var toggleAccordion = function toggleAccordion() {
    return setAccordionOpen(!accordionOpen);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSection, {
    variant: "2Col",
    sticky: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      alignSelf: "flex-start",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Sticky */.Le, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseIconWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseIcon, {
            src: courseIcon.src,
            width: "29",
            height: "29",
            alt: courseIcon.title
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h3",
            variant: "h2",
            children: title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LabelText/* default */.Z, {
            courseNumber: courseNumber,
            children: [lessons.length, " Lessons"]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* Description */.dk, {
            variant: "pMedium",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
              tag: "div",
              variant: "h4",
              children: CourseSection_copy.listHeading
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, {
              children: lessons.map(function (lesson) {
                return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem, {
                  children: lesson.title
                }, lesson.lessonNumber);
              })
            })]
          })]
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      "data-testid": "available-courses",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LessonCard_LessonCard/* default */.Z, {
        lesson: lessons[0]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* Header */.h4, {
          onClick: toggleAccordion,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* TitleWrapper */.$t, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Title */.Dx, {
              children: CourseSection_copy.accordionTitle
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Icon */.JO, {
            opened: accordionOpen
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Body */.uT, {
          children: accordionOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledContentWrapper, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardList, {
              children: lessons.slice(1).map(function (lesson) {
                return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LessonCard_LessonCard/* default */.Z, {
                  lesson: lesson
                }, lesson.lessonNumber);
              })
            })
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var AvailableCourses_CourseSection = (CourseSection);

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e7k9xy16"
} : 0)(Section/* Copy */.CK, "{position:relative;height:100%;}", Section/* Sticky */.Le, "{top:144px;}" + ( true ? "" : 0));

var CourseIconWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e7k9xy15"
} : 0)( true ? {
  name: "xkdi05",
  styles: "margin-bottom:8px;display:block;width:29px;height:29px"
} : 0);

var CourseIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e7k9xy14"
} : 0)( true ? {
  name: "15bqkea",
  styles: "width:29px;height:29px"
} : 0);

var List = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e7k9xy13"
} : 0)( true ? {
  name: "1n2qanb",
  styles: "padding-left:24px"
} : 0);

var ListItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "e7k9xy12"
} : 0)( true ? "" : 0);

var CardList = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e7k9xy11"
} : 0)( true ? {
  name: "6z1g9f",
  styles: "display:grid;grid-auto-flow:row;gap:32px"
} : 0);

var StyledContentWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Accordion/* ContentWrapper */.vs,  true ? {
  target: "e7k9xy10"
} : 0)( true ? {
  name: "1h8nup8",
  styles: "overflow:visible"
} : 0);
;// CONCATENATED MODULE: ./src/views/Academy/LandingPage/components/AvailableCourses/AvailableCourses.tsx






var AvailableCourses_copy = {
  heading: "Available Courses"
};

var AvailableCourses = function AvailableCourses(_ref) {
  var courses = _ref.courses;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AvailableCourses_StyledSection, {
    variant: "noCopy",
    sticky: true,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyText, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: AvailableCourses_copy.heading
        })
      }), courses.map(function (course) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AvailableCourses_CourseSection, {
          course: course
        }, course.courseNumber);
      })]
    })
  });
};

var AvailableCourses_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1gwxm7l1"
} : 0)("&>", Section/* Wrapper */.im, "{padding-left:0;padding-right:0;}" + ( true ? "" : 0));

var StyledCopyText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "e1gwxm7l0"
} : 0)("padding:0 24px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("sm");
}, "{padding:0 40px;}", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{padding:0 80px;}" + ( true ? "" : 0));

/* harmony default export */ var AvailableCourses_AvailableCourses = (AvailableCourses);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/index.ts + 1 modules
var LogoCarousel = __webpack_require__(6087);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/data.tsx
var LogoCarousel_data = __webpack_require__(43787);
// EXTERNAL MODULE: ./src/views/Academy/components/EmailFormSection/EmailFormSection.tsx
var EmailFormSection = __webpack_require__(33446);
;// CONCATENATED MODULE: ./src/views/Academy/LandingPage/components/CtaSection/CtaSection.tsx


function CtaSection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var CtaSection_copy = {
  heading: "We empower every team with good data",
  description: "Segment is a customer data platform that helps your entire company become analytics experts. We collect user events from your web and mobile apps, and make it possible for every team to use that data to make decisions, power tools, and drive growth.",
  ctaTitle: "Learn more",
  ctaHref: "/customer-data-platform/",
  logoCarouselHeading: "The best companies are built on unified customer data"
};
var logos = [LogoCarousel_data/* carouselLogos.IBM */.j.IBM, LogoCarousel_data/* carouselLogos.DIGITAL_OCEAN */.j.DIGITAL_OCEAN, LogoCarousel_data/* carouselLogos.ATLASSIAN */.j.ATLASSIAN, LogoCarousel_data/* carouselLogos.TRIVAGO */.j.TRIVAGO, LogoCarousel_data/* carouselLogos.LEVIS */.j.LEVIS, LogoCarousel_data/* carouselLogos.FOX */.j.FOX];

var CtaSection = function CtaSection() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CtaSection_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailFormSection/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CtaSection_StyledCopyTextBase, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextHeading, {
            tag: "h3",
            children: CtaSection_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pLarge",
            children: CtaSection_copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
            href: (0,getAbsoluteUrl/* default */.Z)(CtaSection_copy.ctaHref, pageConfig),
            children: CtaSection_copy.ctaTitle
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLogoCarousel, {
          heading: CtaSection_copy.logoCarouselHeading,
          logos: logos
        })
      })]
    })]
  });
};

var StyledLogoCarousel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(LogoCarousel["default"],  true ? {
  target: "et18s8z4"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{padding-top:40px;}" + ( true ? "" : 0));

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "et18s8z3"
} : 0)(Section/* Wrapper */.im, "{padding-top:40px;}" + ( true ? "" : 0));

var StyledCopyTextHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "et18s8z2"
} : 0)( true ? {
  name: "1ktn3fc",
  styles: "max-width:400px;margin:0 auto"
} : 0);

var CtaSection_StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "et18s8z1"
} : 0)( true ? {
  name: "837xmr",
  styles: "max-width:684px"
} : 0);

var CtaSection_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "et18s8z0"
} : 0)( true ? "" : 0);

/* harmony default export */ var CtaSection_CtaSection = (CtaSection);
// EXTERNAL MODULE: ./src/views/Academy/assets/OgAcademy.png
var OgAcademy = __webpack_require__(76158);
var OgAcademy_default = /*#__PURE__*/__webpack_require__.n(OgAcademy);
;// CONCATENATED MODULE: ./src/views/Academy/LandingPage/Academy.tsx














var Academy_copy = {
  pageTitle: "Academy | Twilio Segment",
  pageDescription: "Segment is a customer data platform (CDP) that helps you collect, clean, and activate your customer data."
};

var AcademyView = function AcademyView() {
  var _useCoursesQuery = (0,queries/* useCoursesQuery */.x5)({
    args: []
  }),
      courses = _useCoursesQuery.data;

  if (!courses) throw new Error("Courses data is missing. Make sure it is preloaded");
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: Academy_copy.pageTitle,
      pageDescription: Academy_copy.pageDescription,
      pageOG: (OgAcademy_default()),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation2/* default */.Z, {
        after: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnav/* default */.Z, {
          data: courses.map(function (course) {
            return {
              title: course.title,
              courseNumber: course.courseNumber,
              slug: course.slug,
              lessons: course.lessons.map(function (lesson) {
                return {
                  title: lesson.title,
                  slug: lesson.slug
                };
              })
            };
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeaturedLessons_FeaturedLessons, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AvailableCourses_AvailableCourses, {
          courses: courses
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LightBackground, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaSection_CtaSection, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
        })]
      })]
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "estippp1"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var LightBackground = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "estippp0"
} : 0)("background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var Academy = (AcademyView);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ./src/pages/academy/index.tsx





var AcademyPage = function AcademyPage() {
  var staticSiteBackend = (0,react.useMemo)(function () {
    return (0,contexts_staticSiteBackend/* createStaticSiteBackend */.I4)();
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contexts_staticSiteBackend/* StaticSiteBackendProvider */.D1, {
    value: staticSiteBackend,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Academy, {})
  });
};

var __N_SSG = true;
/* harmony default export */ var academy = (AcademyPage);

/***/ }),

/***/ 6087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ LogoCarousel_LogoCarousel; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/recipes/LogoCarousel/index.ts + 8 modules
var LogoCarousel = __webpack_require__(74595);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/data.tsx
var data = __webpack_require__(43787);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/LogoCarousel/LogoCarousel.tsx


var _excluded = ["heading", "logos", "appearance", "headingVariant"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var getDefaultLogos = function getDefaultLogos(logosMap) {
  return [logosMap.DIGITAL_OCEAN, logosMap.IBM, logosMap.DOMINOS, logosMap.ANHEUSER_BUSCH, logosMap.VMWARE, logosMap.LEVIS, logosMap.LOG_ME_IN, logosMap.CLEAR_SCORE, logosMap.VACASA, logosMap.STAPLES, logosMap.INTUIT, logosMap.THE_SKIMM, logosMap.DRIFT, logosMap.ALLERGAN, logosMap.GLOSSIER, logosMap.AB_IN_BEV];
};

var LogoCarouselTemplate = function LogoCarouselTemplate(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Join the 25,000+ companies using the Segment platform" : _ref$heading,
      externalLogos = _ref.logos,
      externalAppearance = _ref.appearance,
      headingVariant = _ref.headingVariant,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var finalLogos = externalLogos !== null && externalLogos !== void 0 ? externalLogos : getDefaultLogos(appearance === "twilioLight" ? data/* carouselLogos */.j : data/* carouselLogosMono */.G);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LogoCarousel/* default */.ZP, _objectSpread(_objectSpread({}, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* Heading */.X6, {
      variant: headingVariant,
      children: heading
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* LogoTrack */.xS, {
      icons: finalLogos
    })]
  }));
};

/* harmony default export */ var LogoCarousel_LogoCarousel = (LogoCarouselTemplate);
;// CONCATENATED MODULE: ../../libs/templates/LogoCarousel/index.ts


/***/ }),

/***/ 658:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/academy",
      function () {
        return __webpack_require__(27456);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useInterval = function (callback, delay) {
    var savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function () { });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        savedCallback.current = callback;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (delay !== null) {
            var interval_1 = setInterval(function () { return savedCallback.current(); }, delay || 0);
            return function () { return clearInterval(interval_1); };
        }
        return undefined;
    }, [delay]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useInterval);


/***/ }),

/***/ 82967:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-536835935e0a40295bfcc7e554601254.png";

/***/ }),

/***/ 76158:
/***/ (function(module) {

module.exports = "/_next/static/images/OgAcademy-dd004474a57c04b98846f11d2350186e.png";

/***/ }),

/***/ 35784:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-39b76d3e020036912eb5c3ab279dcc0f.webp";

/***/ }),

/***/ 3289:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-bba0e850862324d2ee38c2650641dd50.webp";

/***/ }),

/***/ 75536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ useAnimation; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(9340);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/animation.mjs
var animation = __webpack_require__(59413);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/setters.mjs + 3 modules
var setters = __webpack_require__(18617);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/animation-controls.mjs





/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    var hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     * TODO: Remove this as animations should only run in effects
     */
    var pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     */
    var subscribers = new Set();
    var controls = {
        subscribe: function (visualElement) {
            subscribers.add(visualElement);
            return function () { return void subscribers.delete(visualElement); };
        },
        start: function (definition, transitionOverride) {
            /**
             * TODO: We only perform this hasMounted check because in Framer we used to
             * encourage the ability to start an animation within the render phase. This
             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
             * we can ditch this.
             */
            if (hasMounted) {
                var animations_1 = [];
                subscribers.forEach(function (visualElement) {
                    animations_1.push((0,animation/* animateVisualElement */.d5)(visualElement, definition, {
                        transitionOverride: transitionOverride,
                    }));
                });
                return Promise.all(animations_1);
            }
            else {
                return new Promise(function (resolve) {
                    pendingAnimations.push({
                        animation: [definition, transitionOverride],
                        resolve: resolve,
                    });
                });
            }
        },
        set: function (definition) {
            (0,hey_listen_es/* invariant */.k)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach(function (visualElement) {
                (0,setters/* setValues */.gg)(visualElement, definition);
            });
        },
        stop: function () {
            subscribers.forEach(function (visualElement) {
                (0,animation/* stopAnimation */.p_)(visualElement);
            });
        },
        mount: function () {
            hasMounted = true;
            pendingAnimations.forEach(function (_a) {
                var animation = _a.animation, resolve = _a.resolve;
                controls.start.apply(controls, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(animation), false)).then(resolve);
            });
            return function () {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/use-animation.mjs




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimation() {
    var controls = (0,use_constant/* useConstant */.h)(animationControls);
    (0,react.useEffect)(controls.mount, []);
    return controls;
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,8943,6234,4136,2073,6784,8392,5735,2429,2609,948,8187,3996,7947,7960,6012,7079,4881,1385,5062,9833,2588,9774,2888,179], function() { return __webpack_exec__(658); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);